import { ROLES } from 'utils/constants'
import { map, flatMap } from 'lodash'

const navigation = [
  {
    path: '/',
    name: 'Dashboard',
    component: 'Dashboard',
    subnav: null,
  },
  {
    path: '/save',
    redirect: '/wallet',
    component: 'WalletPage',
    subnav: null,
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: 'WalletPage',
    subnav: null,
  },
  {
    path: '/shop-travel/:pageID',
    name: 'Shop Travel',
    component: 'ShopTravelPage',
  },
  {
    path: '/trip-planning/my-trips/budget/:id',
    name: 'Trip Budget Details',
    component: 'TripBudgetDetailsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/trip-planning/budgets',
    name: 'Trip Budgets',
    component: 'TripBudgetsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/trip-planning/my-trips',
    name: 'My Trips',
    component: 'MyTripsPage',
  },
  {
    path: '/trip-planning/my-trips/:id',
    name: 'Trip Details',
    component: 'TripDetailsPage',
    hide: true,
  },
  {
    path: '/my-account',
    name: 'My Account',
    component: 'AccountPage',
    hide: true,
  },
  {
    path: '/company',
    name: 'Company',
    component: 'CompanyPage',
  },
  {
    path: '/admin',
    name: 'Admin',
    redirect: '/admin/account-details',
    component: 'AdminPage',
    hide: true,
    roles: [ROLES.ADMIN],
  },
  {
    path: '/admin/:pageID',
    name: 'Admin',
    component: 'AdminPage',
    hide: true,
    roles: [ROLES.ADMIN],
  },
  {
    // path: '/admin/:pageID',
    name: 'Company Tools',
    roles: [ROLES.ADMIN, ROLES.MANAGER],
    id: 'admin-manager-drawer',
    subnav: [
      {
        path: '/admin/account-details',
        name: 'Admin',
        roles: [ROLES.ADMIN],
      },
      {
        path: '/admin/user-management',
        name: 'User Management',
        hide: true,
        roles: [ROLES.ADMIN],
      },
      {
        path: '/admin/budgeting',
        name: 'Budgeting',
        hide: true,
        roles: [ROLES.ADMIN],
      },
      {
        path: '/advanced-stats',
        name: 'Advanced Stats',
        component: 'AdvancedStatsPage',
        // hide: true,
        roles: [ROLES.ADMIN],
      },
      {
        path: '/my-team',
        name: 'My Team',
        component: 'MyTeamPage',
        roles: [ROLES.MANAGER],
      },
    ],
  },
  {
    path: '/admin/company',
    name: 'Admin',
    redirect: '/admin/account-details',
    // component: 'AdminPage',
    subnav: null,
    hide: true,
    roles: [ROLES.ADMIN],
  },
  {
    path: '/admin/:id',
    name: 'Admin',
    component: 'AdminPage',
    subnav: null,
    hide: true,
    roles: [ROLES.ADMIN],
  },
  // {
  //   path: '/admin/reporting',
  //   name: 'Admin',
  //   component: 'AdminPage',
  //   subnav: null,
  //   hide: true,
  //   roles: [ROLES.ADMIN],
  // },
  {
    path: '/budgets',
    name: 'Budgets',
    component: 'BudgetsPage',
    subnav: null,
    hide: true,
    roles: [ROLES.ADMIN],
  },
  {
    path: '/budget/:id',
    name: 'Budgets',
    component: 'BudgetDetailsPage',
    subnav: null,
    hide: true,
    roles: [ROLES.ADMIN, ROLES.MANAGER],
  },
  {
    path: '/budget-settings/:id',
    name: 'Budgets',
    component: 'BudgetSettingsPage',
    subnav: null,
    hide: true,
    roles: [ROLES.ADMIN],
  },
  {
    path: '/destinations/:id',
    name: 'Destination Details',
    component: 'DestinationDetailsPage',
    hide: true,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: 'LogoutPage',
    hide: true,
  },
  {
    path: '/statements/admin',
    redirect: '/admin/statements?view=account-activity',
    name: 'Statements',
    component: 'AdminStatementsPage',
    subnav: null,
    hide: true,
    roles: [ROLES.ADMIN],
  },
  {
    path: '/statements',
    name: 'Statements',
    redirect: '/statements/user',
    subnav: null,
    hide: true,
  },
  {
    path: '/statements/user',
    name: 'Statements',
    component: 'UserStatementsPage',
    subnav: null,
    hide: true,
  },
  {
    path: '/statements/:category',
    name: 'Statements',
    component: 'StatementsPage',
    subnav: null,
    hide: true,
  },
  {
    path: '/statements/:category/:id',
    name: 'Statements',
    component: 'StatementsPage',
    subnav: null,
    hide: true,
  },
  {
    path: '/experiences/vendor/:id',
    name: 'Vendor Details',
    component: 'VendorDetailsPage',
    hide: true,
  },
  {
    path: '/experiences/things-to-do',
    name: 'Things To Do',
    component: 'ThingsToDoPage',
    hide: true,
  },
  {
    path: '/experiences/guided-tours/:id',
    name: 'Guided Tours',
    component: 'GuidedToursPage',
    hide: true,
  },
  {
    path: '/experiences/guided-tours/:id/:location_id',
    name: 'Guided Tours',
    component: 'GuidedToursPage',
    hide: true,
  },
 {
    path: '/experiences/:id',
    name: 'Experience Collections',
    component: 'ExperienceResultsPage',
    hide: true,
  },
  {
    path: '/experience/things-to-do/:id',
    name: 'Experience Details',
    component: 'HolibobExperienceDetailsPage',
    hide: true,
  },
  {
    path: '/experience/things-to-do/:id/:bookingID',
    name: 'Experience Details',
    component: 'HolibobExperienceDetailsPage',
    hide: true,
  },
  {
    path: '/experience/:id',
    name: 'Experience Details',
    component: 'ExperienceDetailsPage',
    hide: true,
  },
  {
    path: '/tour/:cityID/:tourID',
    name: 'Tour Details',
    component: 'TourDetailsPage',
    hide: true,
  },
  {
    path: '/tour/:cityID/:tourID/:book',
    name: 'Tour Details',
    component: 'TourDetailsPage',
    hide: true,
  },
  {
    path: '/faq/:pageID',
    name: 'Frequently Asked Questions',
    component: 'FAQPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/onboarding/:pageID',
    name: 'Onboarding',
    component: 'OnboardingPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    redirect: '/onboarding/welcome',
    component: 'OnboardingPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/upload-log',
    name: 'Upload Log',
    component: 'UploadLogPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/reward-log',
    name: 'Reward Log',
    component: 'RewardLogPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/settings',
    name: 'Settings',
    component: 'SettingsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/employee-sync-status',
    name: 'Employee Sync Statuses',
    component: 'EmployeeSyncStatusPage',
    hide: true,
    auth: true,
    subnav: null,
    roles: [ROLES.ADMIN],
  },
  {
    path: '/reset',
    name: 'Reset',
    component: 'ResetPage',
    hide: true,
    auth: true,
    subnav: null,
    dev: true,
  },
  {
    path: '/donde-top-fives',
    name: 'Top Fives',
    component: 'TopFivesPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/trip-planning/my-collections',
    name: 'My Collections',
    component: 'MyCollectionsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/trip-planning/my-collections/:id',
    name: 'Collection Details',
    component: 'CollectionDetailsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/hotels',
    redirect: '/shop-travel/stays/hotels',
    name: 'Hotels',
    component: 'HotelResultsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/hotel/:id',
    name: 'Hotel Details',
    component: 'HotelDetailsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/hotel/:id/:bundleID',
    name: 'Hotel Details',
    component: 'HotelDetailsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/shop-travel/stays/hotels',
    name: 'Hotels',
    component: 'HotelResultsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/shop-travel/stays/hotel/:id',
    name: 'Hotel Details',
    component: 'HotelDetailsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/shop-travel/stays/hotel/:id/:bundleID',
    name: 'Hotel Details',
    component: 'HotelDetailsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/travel-companion/:id',
    name: 'Travel Companion',
    component: 'TravelCompanionDetailsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/shop-travel/trip-protection/customize',
    name: 'Customize Your Coverage',
    component: 'CustomizeYourCoveragePage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/shop-travel/trip-protection/multi-trip-overview',
    name: 'Included in your policy',
    component: 'MultiTripOverviewPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/policy-application/:pageID',
    name: 'Policy Application',
    component: 'PolicyApplicationPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/my-trip-protection',
    name: 'Your Trip Protection',
    component: 'MyTripProtectionPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/shop-travel/trip-protection/:pageID',
    name: 'Trip Protection Details',
    component: 'TripProtectionDetailsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/admin-onboarding/:pageID',
    name: 'Admin Onboarding',
    component: 'AdminOnboardingPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/admin-onboarding',
    name: 'Admin Onboarding',
    redirect: '/admin-onboarding/welcome',
    component: 'AdminOnboardingPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/destination',
    name: 'Destination',
    component: 'AIDestinationPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/wallet/virtual-card',
    name: 'Virtual Cards',
    component: 'VirtualCardPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/wallet/virtual-cards',
    name: 'Virtual Cards',
    component: 'VirtualCardsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/wallet/virtual-card/:id',
    name: 'Virtual Card',
    component: 'VirtualCardDetailsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  // {
  //   path: '/shop-travel/stays/long-stays',
  //   name: 'Long Stays',
  //   component: 'ShopTravelLongStaysPage',
  //   hide: true,
  //   auth: true,
  //   subnav: null,
  // },
  {
    path: '/shop-travel/long-stays/results',
    name: 'Long Stays Results',
    component: 'LongStaysResultsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/shop-travel/long-stay/:id',
    name: 'Long Stay Details',
    component: 'LongStayDetailsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/shop-travel/long-stay/:id/:inventoryID',
    name: 'Long Stay Details',
    component: 'LongStayDetailsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/shop-travel/travel-partners',
    name: 'Travel Partners',
    component: 'ShopTravelPartnersPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/trip-planning',
    name: 'Trip Planning',
    component: 'TripPlanningPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/wallet/donde-rewards',
    name: 'Dónde Rewards',
    component: 'DondeRewardsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
  {
    path: '/shop-travel/travel-partners/:pageID',
    name: 'Travel Partner Details',
    component: 'TravelPartnerDetailsPage',
    hide: true,
    auth: true,
    subnav: null,
  },
]

const subnavItems = flatMap(navigation, ({ name, subnav }) =>
  map(subnav, subnavItem => ({ name, ...subnavItem }))
)

export const flatNav = [...navigation, ...subnavItems]
export default navigation
